import { useModalBehavior } from "@/hooks/behaviors";
import type { SrmSupplierAccessEvaluationPage } from "@/types/apis";
import type { FormInstance } from "antd";
import { useCallback, useState } from "react";

export const useAdmissionAssessmentSelect = (form: FormInstance) => {
  const { open, openModal, closeModal } = useModalBehavior();

  // 准入评估详情映射 {字段名: 准入评估详情}，用于回显名称
  const [assessmentsMap, setAssessmentsMap] = useState<
    Record<string, SrmSupplierAccessEvaluationPage>
  >({});

  // 添加选中的准入评估
  const addAdmissionAssessment = useCallback(
    (fieldName: string, assessment: SrmSupplierAccessEvaluationPage) => {
      form.setFieldValue(fieldName, assessment.id);
      setAssessmentsMap((prev) => ({
        ...prev,
        [fieldName]: assessment,
      }));
    },
    [form],
  );

  // 移除准入评估
  const removeAdmissionAssessment = useCallback(
    (fieldName: string) => {
      form.setFieldValue(fieldName, "");
      setAssessmentsMap((prev) => {
        const newMap = { ...prev };
        delete newMap[fieldName];
        return newMap;
      });
    },
    [form],
  );

  // 获取指定字段的准入评估详情
  const getAdmissionAssessment = useCallback(
    (fieldName: string) => assessmentsMap[fieldName],
    [assessmentsMap],
  );

  return {
    admissionAssessmentOpen: open,
    openAdmissionAssessmentModal: openModal,
    closeAdmissionAssessmentModal: closeModal,
    addAdmissionAssessment,
    removeAdmissionAssessment,
    getAdmissionAssessment,
  };
};
